import React, { createContext, useState, useContext, useEffect } from "react";
import api from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem("auth_token"));

  // Check if user is authenticated on mount
  useEffect(() => {
    const checkAuth = async () => {
      const storedToken = localStorage.getItem("auth_token");
      if (storedToken) {
        try {
          const response = await api.get("/auth/me");
          setUser(response.data);
          setToken(storedToken);
        } catch (error) {
          console.error("Auth check failed:", error);
          // Token is invalid, clear it
          localStorage.removeItem("auth_token");
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const requestMagicLink = async (email) => {
    try {
      const response = await api.post("/auth/request-magic-link", {
        email,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const verifyMagicLink = async (token) => {
    try {
      const response = await api.get("/auth/verify", {
        params: { token },
      });
      const { access_token, user } = response.data;

      // Store token
      localStorage.setItem("auth_token", access_token);
      setToken(access_token);
      setUser(user);

      return user;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem("auth_token");
    setToken(null);
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const response = await api.get("/auth/me");
      setUser(response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to refresh user:", error);
      throw error;
    }
  };

  const value = {
    user,
    token,
    loading,
    isAuthenticated: !!user,
    requestMagicLink,
    verifyMagicLink,
    logout,
    refreshUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
